import { JxtLoader } from '@jooxter/ui';

/**
 * The app's full-page loader, while it starts (translations, then the user). Same look as the loader
 * of index.html, shown before the scripts run: no blank page in between. It also waits for the first
 * page's chunk (AppRoutes' Suspense): one loader, in one place, until the page shows with its navbar.
 */
export const AppLoader = () => (
  <div className="flex flex-1 items-center justify-center">
    <JxtLoader />
  </div>
);
